/* tslint:disable */

declare var Object: any;
export interface SFAnnouncementInterface {
  "id"?: number;
}

export class SFAnnouncement implements SFAnnouncementInterface {
  "id": number;
  constructor(data?: SFAnnouncementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAnnouncement`.
   */
  public static getModelName() {
    return "SFAnnouncement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAnnouncement for dynamic purposes.
  **/
  public static factory(data: SFAnnouncementInterface): SFAnnouncement{
    return new SFAnnouncement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAnnouncement',
      plural: 'SFAnnouncements',
      path: 'SFAnnouncements',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAnnouncement.ts